import React, { useEffect, useState } from 'react';
import {
  Container,
  Title,
  SelectedTab,
  SelectTabWrapper,
  OptionWrapper,
  Option,
  Table
} from './styled';
import { toJS } from 'mobx';
import style from '../../../../../routes/score/baseball/match/relativeRecord/battingTable/style.module.scss';

const BatterStat = ({ data }) => {
  const [selectedPosition, setSelectedPosition] = useState('home');
  const [viewType, setViewType] = useState('season');
  const { playerStat } = data;
  const [viewData, setViewData] = useState([]);

  const handleChangePosition = (position) => {
    setSelectedPosition(position);
    setViewData(playerStat[position].seasonBatList);
  };

  const handleChangeViewType = (changeType) => {
    setViewType(changeType);
    if (changeType === 'season') {
      setViewData(playerStat[selectedPosition].seasonBatList);
    } else {
      setViewData(playerStat[selectedPosition].seasonVsBatList);
    }
  };

  useEffect(() => {
    setViewData(playerStat[selectedPosition].seasonBatList);
  }, []);

  return (
    <Container>
      <Title>
        타자 전력
        <OptionWrapper>
          <Option
            isSelected={viewType === 'season'}
            onClick={() => handleChangeViewType('season')}
          >
            시즌기록
          </Option>
          <Option
            isSelected={viewType === 'relative'}
            onClick={() => handleChangeViewType('relative')}
          >
            상대전적
          </Option>
        </OptionWrapper>
      </Title>
      <SelectTabWrapper>
        <SelectedTab
          isSelected={selectedPosition === 'home'}
          onClick={() => handleChangePosition('home')}
        >
          {data.record.tabs.home}
        </SelectedTab>
        <SelectedTab
          isSelected={selectedPosition === 'away'}
          onClick={() => handleChangePosition('away')}
        >
          {data.record.tabs.away}
        </SelectedTab>
      </SelectTabWrapper>

      <Table>
        <thead>
          <tr>
            <th>선수명</th>
            <th>타율</th>
            <th>안타</th>
            <th>타점</th>
            <th>OPS</th>
          </tr>
        </thead>
        <tbody>
          {viewData.map((value, key) => {
            return (
              <tr key={key}>
                <td>{value.player.displayName}</td>
                <td>{value.batAvg.toFixed(3)}</td>
                <td>{value.batHit}</td>
                <td>{value.batRbi}</td>
                <td>{value.batOps.toFixed(3)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
};

export default BatterStat;
